import PropTypes from 'prop-types'
import { Button, Flex, FormControl, FormLabel, Grid, GridItem, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Text, useDisclosure, VStack } from '@chakra-ui/react'
import { PROJECT_INSTALLER_PO_CATEGORIES } from './ModalProjectInstallerPOForm'
import { getAssetUrl } from 'lib'
import { useEffect, useState } from 'react'
import { deleteProjectInstallerPO, getUserById } from 'api'
import { format as formatDate } from 'date-fns'
import { ModalPasswordConfirmation } from 'components/common'
import { useAppContext } from 'hooks/useAppContext'

export const ModalProjectInstallerPOApproved = ({ isOpen, onClose, po, reload }) => {
  const { createToast } = useAppContext()
  const [approvedUser, setApprovedUser] = useState(null)
  const disclosureRemovePO = useDisclosure()

  useEffect(() => {
    if (po?.approvedUserId) {
      try {
        const data = getUserById(po?.approvedUserId)
        setApprovedUser(data)
      } catch (err) {
      }
    }
  }, [po?.approvedUserId])

  const handleRemove = async (id) => {
    try {
      await deleteProjectInstallerPO(id)
      disclosureRemovePO.onClose()
      onClose()
      reload()
      createToast('success', 'Success', 'Po removed.')
    } catch {
      createToast('error', 'Error', 'Failed to remove the PO.')
    }
  }

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="2xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Installer PO</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack alignItems="none" gap={4}>
              <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                <GridItem>
                  <FormControl>
                    <FormLabel>Item Name</FormLabel>
                    <Select name="name" value={po?.name || ''} isDisabled={true} placeholder="Select">
                      {Object.keys(PROJECT_INSTALLER_PO_CATEGORIES).map(v =>
                        <option key={PROJECT_INSTALLER_PO_CATEGORIES[v]} value={PROJECT_INSTALLER_PO_CATEGORIES[v]}>{PROJECT_INSTALLER_PO_CATEGORIES[v]}</option>
                      )}
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem></GridItem>
                <GridItem>
                  <FormControl>
                    <Button size="sm" fontWeight="medium" variant="link" color="blue" onClick={() => window.open(getAssetUrl(po.signedDoc))}>View Signed Doc</Button>
                  </FormControl>
                </GridItem>
                <GridItem></GridItem>
                <GridItem>
                  <Text fontSize="sm">Approved by {`${approvedUser?.firstname || ''} ${approvedUser?.lastname || ''}`} on {po?.approvedAt ? formatDate(new Date(po?.approvedAt), 'MM/dd/yyyy') : ''}</Text>
                </GridItem>
              </Grid>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Flex justifyContent="flex-end" gap={4}>
              {/* <Button type="submit" colorScheme="blue" isLoading={isSaving}>
                Approve
              </Button> */}
              <Button type="button" colorScheme="red" onClick={() => disclosureRemovePO.onOpen()}>
                Delete
              </Button>
              <Button onClick={onClose}>Close</Button>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {disclosureRemovePO.isOpen && (
        <ModalPasswordConfirmation
          heading="Are you sure to remove the PO?"
          btnConfirmLabel="Remove"
          onConfirm={() => handleRemove(po.id)}
          {...disclosureRemovePO}
        />
      )}
    </>
  )
}

ModalProjectInstallerPOApproved.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  po: PropTypes.object,
  reload: PropTypes.func
}
